import { ModelInfo } from "../types/Model.js";
import { AbstractLLMInferenceEngine } from "./AbstractLLMInferenceEngine.js";
import axios from "axios";
class ChatMessageBody {
    role;
    content;
    constructor(role, content) {
        this.role = role;
        this.content = content;
    }
}
class ChatInferenceRequest {
    messages;
    model;
    constructor(messages, model) {
        this.messages = messages;
        this.model = model;
    }
}
class CompletionInferenceRequest {
    prompt;
    model;
    constructor(prompt, model) {
        this.prompt = prompt;
        this.model = model;
    }
}
export class OpenAIAzureInferenceEngine extends AbstractLLMInferenceEngine {
    availableModels = {
        'openai-gpt-4o': new ModelInfo('openai-gpt-4o'),
        'openai-gpt-4o-mini': new ModelInfo('openai-gpt-4o-mini'),
        'azure-gpt-4o': new ModelInfo('azure-gpt-4o'),
        'azure-gpt-4o-mini': new ModelInfo('azure-gpt-4o-mini'),
    };
    url;
    apiKey;
    httpClient;
    model = 'openai-gpt-4o';
    endpoints = {
        chat: {
            path: '/api/v1/llm-inference-chat',
            method: 'POST',
            type: ChatInferenceRequest
        },
        completion: {
            path: '/api/v1/llm-inference-completion',
            method: 'POST',
            type: CompletionInferenceRequest
        }
    };
    constructor(model, url, apiKey) {
        super();
        this.url = url;
        this.apiKey = apiKey;
        this.model = model;
        this.httpClient = axios.create({
            baseURL: this.url,
            timeout: 64000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.apiKey}`,
            },
        });
    }
    async runChatInference(chat) {
        const data = new ChatInferenceRequest(chat.map((message) => new ChatMessageBody(message.role, message.content)), this.model);
        const result = await this.httpClient.post(this.endpoints.chat.path, data);
        return result.data;
    }
    async runCompletionInference(prompt) {
        const data = new CompletionInferenceRequest(prompt, this.model);
        const result = await this.httpClient.post(this.endpoints.completion.path, data);
        return result.data['content'];
    }
    progressCallback(initProgress) {
        throw new Error("Method not implemented.");
    }
}
//# sourceMappingURL=OpenAIAzureLLMInferences.js.map